module.exports = __webpack_public_path__ + "static/media/eye_closed.fd1bc1c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/eye_closed.svg
// module id = 66
// module chunks = 3